import React from 'react';
import { Field } from 'react-form';
import Phone from 'react-phone-number-input';

import InfoButton from '../../InfoButton';

import styles from '../Input/Input.scss';

const PhoneNumber = props => (
    <Field field={props.field} validate={props.validate}>
        { fieldApi => {
            const {
                onChange,
                onBlur,
                field,
                validate,
                id,
                label,
                hiddenLabel,
                description,
                placeholder,
                hoverText,
                defaultCountry,
                themeV3,
                'data-testid': dataTestId,
                ...rest
            } = props;

            const { value, error, warning, touched, setValue, setTouched } = fieldApi;

            const inputProps = {
                ...rest,
                id,
                className: `form-control ${styles.formControl}`,
                type: 'text',
                value: value || '',
                placeholder,
                country: defaultCountry || 'US',
                flagsPath: '/img/flags/',
                onChange: value => {
                    setValue(value);
                    if (onChange) {
                        onChange(value);
                    }
                },
                onBlur: e => {
                    setTouched();
                    if (onBlur) {
                        onBlur(e);
                    }
                },
            };

            return (
                <div className={`form-group ${(touched && error) && `${styles.isInvalid} is-invalid`} ${description && 'description'} ${styles.formInput} ${themeV3 ? styles.themeV3 : ''}`} data-testid={dataTestId || undefined}>
                    <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                        {!themeV3 && label}
                        {hoverText && <InfoButton hoverText={hoverText} />}
                    </label>
                    {description && (<small>{description}</small>)}
                    <div className="input-wrapper">
                        <Phone {...inputProps} data-testid={dataTestId && `${dataTestId}.input`} />
                        {!themeV3 && <div className="error-indicator" />}
                        {themeV3 && (
                            <label htmlFor={id}>{label}</label>
                        )}
                    </div>
                    {touched &&
                        ((error && <div className="invalid-feedback" data-testid={dataTestId && `${dataTestId}.error`}>{error}</div>) ||
                        (warning && <div className="warning-feedback" data-testid={dataTestId && `${dataTestId}.warning`}>{warning}</div>))}
                </div>
            );
        }}
    </Field>
);

export default PhoneNumber;
